import { createReducer } from './create';

const initialState = {
    is_loading_food: false,
    food: null,
    confirmed_food: null,

    has_food_step: false,
    step_food_done: true,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: () => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: () => {
        return initialState;
    },
    ['TICKETS/SELECT']: (state, payload) => {
        const food = payload.ticket.food;

        return Object.assign({}, state, {
            food: food,
            has_food_step: food != null,
            step_food_done: food == null,
        });
    },
    ['TICKETS/ADD_SINGLE']: (state, payload) => {
        let added_tickets = [].concat(state.added_tickets);
        added_tickets.push(payload.ticket);

        const food = state.food == null &&
        payload.ticket.food != null
            ? payload.ticket.food
            : state.food != null
                ? state.food
                : null;

        const hasFoodStep = food != null;

        return Object.assign({}, state, {
            food: food,
            has_food_step: hasFoodStep,
            step_food_done: !hasFoodStep,
        });
    },
    ['FOOD/LOAD']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_food: true,
        });
    },
    ['FOOD/LOAD_FINISHED']: (state, payload) => {
        return Object.assign({}, state, {
            is_loading_food: false,
            food: payload.food,
        });
    },
    ['FOOD/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_food: payload.food,
        });
    },
});
